import React from "react";
import { Box, Typography } from "@mui/material";
import { DASH } from "../../pages/Dashboard/dashboardTheme";

/** Tarjeta de sección para gráficas (Dashboard, Análisis, Sucursal). */
export default function ChartSectionCard({
  title,
  subtitle,
  action,
  children,
  noPadding = false,
  tall = false,
  sx = {},
}) {
  return (
    <Box
      sx={{
        bgcolor: DASH.card,
        border: `1px solid ${DASH.border}`,
        borderRadius: DASH.radius,
        overflow: "hidden",
        display: tall ? "flex" : "block",
        flexDirection: tall ? "column" : undefined,
        height: tall ? "100%" : "auto",
        minHeight: tall ? 320 : "auto",
        ...sx,
      }}
    >
      {(title || action) && (
        <Box
          sx={{
            px: 2.5,
            py: 2,
            borderBottom: `1px solid ${DASH.borderLight}`,
            display: "flex",
            alignItems: "flex-start",
            justifyContent: "space-between",
            gap: 1,
            flexShrink: 0,
          }}
        >
          <Box>
            {title && (
              <Typography
                sx={{
                  fontSize: "13px",
                  fontWeight: 600,
                  color: DASH.text,
                  letterSpacing: "-0.02em",
                }}
              >
                {title}
              </Typography>
            )}
            {subtitle && (
              <Typography
                sx={{
                  fontSize: "12px",
                  color: DASH.textMuted,
                  mt: 0.35,
                  fontWeight: 400,
                }}
              >
                {subtitle}
              </Typography>
            )}
          </Box>
          {action}
        </Box>
      )}
      <Box sx={{ p: noPadding ? 0 : 2.5, flex: tall ? 1 : "none", minHeight: tall ? 0 : undefined }}>
        {children}
      </Box>
    </Box>
  );
}
